import styled from 'styled-components';
import color from '../../constants/color';
import materialUI from '../../material-UI';

export const Container: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 18px;
  margin-bottom: 12px;
`;
export const Img: any = styled.img`
`;
export const Info = styled.div`
  font-size: 14px;
  color: ${color.Black};
  margin: 0px 0px 0px 18px;
  font-family: Inter;
`;
export const Avatar = styled(materialUI.Avatar)`
  height: 24px;
  width: 24px;
  margin-left: 18px;
`;
